import { render, staticRenderFns } from "./GraphDetailNone.vue?vue&type=template&id=65362819&scoped=true"
import script from "./GraphDetailNone.vue?vue&type=script&lang=js"
export * from "./GraphDetailNone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65362819",
  null
  
)

export default component.exports